import { render } from "./RoomsDetails.vue?vue&type=template&id=4f3539f9&scoped=true&ts=true"
import script from "./RoomsDetails.vue?vue&type=script&lang=ts"
export * from "./RoomsDetails.vue?vue&type=script&lang=ts"

import "./RoomsDetails.vue?vue&type=style&index=0&id=4f3539f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3539f9"]])

export default __exports__